import {
  LEGAL_LOADING,
  GET_LEGAL,
  GET_LEGAL_SUCCESS,
  GET_LEGAL_FAIL,
  ADD_LEGAL_SUCCESS,
  ADD_LEGAL_FAIL,
  DELETE_LEGAL_SUCCESS,
  DELETE_LEGAL_FAIL,
  UPDATE_LEGAL_SUCCESS,
  UPDATE_LEGAL_FAIL,
  LEGAL_RESET
} from "./actionType";

const INIT_STATE = {
  legals: [],
  error: {},
};

const Legal = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LEGAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_LEGAL:
          return {
            ...state,
            legals: action.payload.data,
            isLegalCreated: false,
            isLegalSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_LEGAL_FAIL:
      switch (action.payload.actionType) {
        case GET_LEGAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isLegalCreated: false,
            isLegalSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_LEGAL: {
      return {
        ...state,
        isLegalCreated: false,
        loading: true,
      };
    }

    case LEGAL_LOADING: {
      return {
        ...state,
        isLegalCreated: false,
        loading: true,
      };
    }

    case ADD_LEGAL_SUCCESS:
      return {
        ...state,
        isLegalCreated: true,
        loading: false,
        legals: [action.payload.data, ...state.legals],
      };

    case ADD_LEGAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_LEGAL_SUCCESS:
      return {
        ...state,
        loading: false,
        isLegalCreated: true,
        legals: state.legals.filter(
          legal => legal.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_LEGAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_LEGAL_SUCCESS:
      return {
        ...state,
        loading: false,
        isLegalCreated: true,
        legals: state.legals.map(legal =>
          legal.id.toString() === action.payload.data.id.toString() ? { ...legal, ...action.payload.data } : legal
        ),
      };

    case UPDATE_LEGAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case LEGAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Legal;